import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const CancelBancoEstadoPayment = () => gql`
  mutation CancelBancoEstadoPayment($params: CancelBancoEstadoPaymentParams!) {
    cancelBancoEstadoPayment(params: $params) {
      id
      deliveryType
      deliveryCost
      totalCost
      mekiCreditsUsed
      onDemand
      payments {
        id
        status
        amount
        paymentMethodType
      }
      address {
        id
        uuid
        apartment
        commune
        street
        streetNumber
        details
        name
      }
      paymentMethod {
        id
        uuid
        type
        data
      }
      status
      orderGroupId
      paidAt
      orderDetails {
        id
        quantity
        price
        product {
          id
          name
          concentration
          quantity
          unit
          format
          imagesUrl
          display
          price
          prescriptionType
          metadata {
            refrigerated
          }
        }
      }
    }
  }
`;

export type CancelBancoEstadoPaymentParams = ResolverParams<{
  orderUuid: string;
}>;

export type CancelBancoEstadoPaymentResponse = {
  cancelBancoEstadoPayment: Order;
};
